/* eslint-disable no-useless-escape */
import { Card } from '../store/types'

export interface ErrorStatus {
  status: boolean
  message: string
}

export const checkId = (id: string) => {
  let validate = { message: '', status: false }
  if (id.length !== 13) {
    validate = {
      status: false,
      message: 'validate-message.identity'
    }
    return validate
  }
  for (let i = 0, sum = 0; i < 12; i++) {
    sum += parseInt(id.charAt(i)) * (13 - i)
    if ((11 - (sum % 11)) % 10 != parseInt(id.charAt(12))) {
      validate = {
        status: false,
        message: 'validate-message.identity'
      }
    } else {
      validate = {
        status: true,
        message: ''
      }
    }
  }
  return validate
}

export const checkPhone = (phoneNumber: string) => {
  let validate: ErrorStatus = { message: '', status: false }
  if (phoneNumber.charAt(0) !== '0' && phoneNumber.charAt(0) !== '') {
    validate = {
      message: 'validate-message.mobile',
      status: false
    }
  } else if (phoneNumber.charAt(0) === '0' && phoneNumber.length !== 10) {
    validate = {
      message: 'validate-message.mobile',
      status: false
    }
  } else if (phoneNumber.length === 0) {
    validate = { message: '', status: false }
  } else {
    validate = { message: '', status: true }
  }
  return validate
}

export const checkEmpty = (input: string, messageData: string) => {
  let validate: ErrorStatus = { message: '', status: false }
  if (input) {
    validate = { message: '', status: true }
    return validate
  } else {
    validate = { message: messageData, status: false }
    return validate
  }
}
export const checkName = (input: string, message: string) => {
  const validate: ErrorStatus = checkEmpty(input, message)
  if (!validate.status) return validate
  const regex = /^[\u0E01-\u0E4E\s]+$/

  if (!regex.test(input)) {
    return { message: 'กรุณากรอกเป็นภาษาไทยเท่านั้น', status: false }
  }

  return { message: '', status: true }
}

export const checkLength = (input: string, exceptLength: number, message: string) => {
  let validate: ErrorStatus = { message: '', status: false }
  if (input.length !== exceptLength) {
    validate = {
      message: `${message}`,
      status: false
    }
    return validate
  } else {
    return {
      message: '',
      status: true
    }
  }
}

export const checkEmailFormat = (mail: string) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return {
      status: true,
      message: ''
    }
  }
  return {
    status: false,
    message: window.bizlink.translate('validate-message.email')
  }
}

export const checkDuplicateProduct = (selectedCard: Card, product: Card[]) => {
  const userProduct = product
  if (!userProduct || userProduct.length === 0) {
    return false
  } else {
    const findCard = userProduct.find((card: Card) => {
      const checkDuplicate =
        `${card.product_mask}_${card.bin_number}` ===
        (selectedCard && `${selectedCard.product_mask}_${selectedCard.bin_number}`)
      return checkDuplicate
    })
    if (findCard) return true
    else return false
  }
}
